export class UserInformation {
  constructor(userInformation) {
    this.id = userInformation.id;  
    this.userInfos = userInformation.userInfos;
    this.todayScore = userInformation.todayScore;
    this.keyData = userInformation.keyData;  
  }
}

